import React from 'react';
import {Modal, ModalContentProps} from '@mantine/core';

export const EtroModalContent: React.FC<ModalContentProps> = props => {
  return <Modal.Content {...props} />;
};
